<template lang="pug">
.content-center
  .pagepanel
    .page-group
      ul#sortable.list-group.sports.ui-sortable(data-role="listview")
        li.list-group-item(:id="index" v-for="index in order" :key="index")
          .form.drag
            span.sort-pic
              img(:src="'/images/icon-sport-svg/' + getSportsImage(index)")
            span.sort-sport {{ sports[index] }}
            span.icon-sequence
</template>

<script>
import config from "@/config";
export default {
  // data: () => ({
  //   order: []
  // }),
  props: {
    order: {
      type: Array,
      default: []
    }
  },
  computed: {
    sports() {
      return this.$store.state.layout.sports;
    }
  },
  mounted() {
    console.log("mounted start")
    $("#sortable").sortable({
      zIndex: 0
    });
    $("#sortable").disableSelection();
    $("#sortable").sortable({
      update: (event, ui) => {
        this.$emit("onUpdate", $("#sortable").sortable("toArray"));
      }
    });
    console.log("mounted end")
  },
  methods: {
    getSportsImage(e) {
      return config.getSportsImage(e);
    }
  }
}
</script>